import { useEffect, useState } from "react";
import { getCoordinationSettings } from "../../helpers/getCoordinationSettings";

export const useFetchCards = () => {

    const [state, setState] = useState({ total: 0, data: [] });

    useEffect(() => {
        getCoordinationSettings().then(cards => {
            setState(cards);
        });
    }, []);

    return { state, setState };
}